import { render } from "./RecordEducationModal.vue?vue&type=template&id=e3da38c8&scoped=true"
import script from "./RecordEducationModal.vue?vue&type=script&lang=js"
export * from "./RecordEducationModal.vue?vue&type=script&lang=js"

import "./RecordEducationModal.vue?vue&type=style&index=0&id=e3da38c8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3da38c8"]])

export default __exports__